import { useEffect, useState } from 'react';

import cardL from '../assets/LTEXT.png';
import cardR from '../assets/RTEXT.png';
import card1 from '../assets/card1.png';

export const VegasScreen: React.FC = () => {
  const [passcode, setPasscode] = useState<string>('');
  const [isUnlocking, setIsUnlocking] = useState<boolean>(false);
  const [isUnlocked, setIsUnlocked] = useState<boolean>(false);

  const [targetName, setTargetName] = useState<string>('');
  const [displayedName, setDisplayedName] = useState<string>('');
  const [isNameDisplayed, setIsNameDisplayed] = useState<boolean>(false);

  const [displayedText, setDisplayedText] = useState<string>('');
  const [isTextDisplayed, setIsTextDisplayed] = useState<boolean>(false);

  const [displayedError, setDisplayedError] = useState<string>('');
  const [isErrorDisplayed, setIsErrorDisplayed] = useState<boolean>(false);

  const [ripped, setRipped] = useState(false);

  const WHATSAPP_GROUP_CHAT_PASSWORDS = [
    'Guneet Singh',
    'Lauren Tom',
    'Rohan Patrick',
    'Shareen Singh',
    'Eden Ben-Benjamin',
    'Camila Perez',
    'Aminah Taguri',
    'Diane Choo',
    'Charlotte Stockdale',
    'Nikisha Patel',
    'Kora Lynah'
  ];

  const TELEGRAM_GROUP_CHAT_PASSWORDS = [
    'Logan Kovary',
    'Alex Napheys',
    'Don Franky Irwin',
    'Sean Matthew English'
  ];

  const PASSCODE_USERS: Record<string, string> = {
    '777': 'Diane Choo',
    'SPLIT SIXES': 'Brian & Emily Leigh',
    'LADY LUCK': 'Casey & Chris Muoio',
    'SNAKE EYES': 'Guneet Singh',
    'ROYAL FLUSH': 'Don Franky Irwin',
    'FULL HOUSE': 'Sean Matthew English',
    'ALL IN': 'Evan Weiss',
    'BLUFF': 'Lauren Tom',
    'JACKPOT': 'Rohan Patrick',
    'HIGH ROLLER': 'Shareen Singh',
    'DOUBLE DOWN': 'Eden Ben-Benjamin',
    'POCKET ACES': 'Logan Kovary',
    'LOADED DICE': 'Camila Perez',
    'LUCKY SEVEN': 'Alex Comerford',
    'HIGH STAKES': 'Aminah Taguri',
    'NO LIMIT': 'Diane Choo',
    'SIN CITY': 'Charlotte Stockdale',
    'NEON LIGHTS': 'Nikisha Patel',
    'GOLDEN NUGGET': 'Kora Lynah',
    'FREE ROLL': 'Alex Napheys',
    'YO 11': 'Cindie & Steve Leigh',
    'PEPPERMILL': 'Grant Hummer',
    'BELLAGIO': 'Cole Rosson',
    'CAESARS PALACE': 'TEST USER'
  }

  const TOS_TEXT = "Jackpot! You have cracked the code and now the house will reveal their cards.";
  const ERROR_TEXT = "House calls your bluff -- wrong password";

  const UNLOCK_PAUSE = 1500;
  const ERROR_DISPLAY_SPEED = 80;
  const NAME_DISPLAY_SPEED = 100;
  const NAME_DISPLAY_PAUSE = 750;
  const TOS_DISPLAY_SPEED = 80;
  const TOS_DISPLAY_PAUSE = 2000;
  const RIP_PAUSE = 4000;

  useEffect(() => {
    if (isNameDisplayed) {
      let index = 0;
      const interval = setInterval(async () => {
        setDisplayedText(TOS_TEXT.slice(0, index + 1));
        index++;
        if (index == TOS_TEXT.length) {
          setTimeout(() => {
            setIsTextDisplayed(true);
            clearInterval(interval);
          }, TOS_DISPLAY_PAUSE);
        }
      }, TOS_DISPLAY_SPEED);
    }
  }, [isNameDisplayed]);

  useEffect(() => {
    if (isUnlocked) {
      let index = 0;
      const interval = setInterval(async () => {
        setDisplayedName(targetName.slice(0, index + 1));
        index++
        if (index == targetName.length) {
          setTimeout(() => {
            setIsNameDisplayed(true);
            clearInterval(interval);
          }, NAME_DISPLAY_PAUSE);
        }
      }, NAME_DISPLAY_SPEED);
    }
  }, [isUnlocked]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRipped(true);
    }, RIP_PAUSE);
    return () => clearTimeout(timer);
  }, [isTextDisplayed]);

  const handleSubmit = () => {
    setIsErrorDisplayed(false);
    setDisplayedError('');
    const target = PASSCODE_USERS[passcode.toUpperCase().trim()];
    if (target) {
      setIsUnlocking(true);
      setTargetName(target);

      setTimeout(() => {
        setIsUnlocked(true);
      }, UNLOCK_PAUSE);
    } else {
      setIsErrorDisplayed(true);
      let index = 0;
      const interval = setInterval(async () => {
        setDisplayedError(ERROR_TEXT.slice(0, index + 1));
        index++;
        if (index == ERROR_TEXT.length) {
          clearInterval(interval);
        }
      }, ERROR_DISPLAY_SPEED)
    }
  }

  const handleMore = () => {
    window.open('https://chat.whatsapp.com/HjQbw6cWMrWGlZaURpfFA8', '_blank');
  }

  const handleMoreTelegram = () => {
    window.open('https://t.me/alwaysbcoding', '_blank');
  }

  return (
    <div className='Screen home-screen'>

      {!isUnlocked && (
        <div className={`enter-passcode ${isUnlocking ? 'unlocking' : ''}`}>
          <h2 className='enter-passcode-text'>ENTER PASSCODE</h2>
          <input
            type='text'
            className='enter-passcode-input'
            placeholder='PASSCODE'
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !isUnlocking) {
                handleSubmit();
              }
            }}
            disabled={isUnlocking} />
          <div
            className='action-button submit'
            onClick={handleSubmit}
            style={{ pointerEvents: isUnlocking ? 'none' : 'auto' }}>
            <p className='action-button-text'>SUBMIT</p>
          </div>
          {isErrorDisplayed && (
            <p className='error-text'>{displayedError}</p>
          )}
        </div>
      )}

      {(isUnlocked && !isTextDisplayed) && (
        <div className='invite-text'>
          <h1 className='invite-name'>{displayedName}</h1>
          <br />
          <h3 className='invite-subtext'>{displayedText}</h3>
        </div>
      )}

      {isTextDisplayed && (
        <div className={`card-container ${ripped ? 'ripped' : ''}`}>
          <div className='card-cover'>
            <img src={cardL} className='card-piece card-piece-l' />
            <img src={cardR} className='card-piece card-piece-r' />
          </div>
          <div className='card' style={{ backgroundImage: `url(${card1})` }}>
            <p className='celebrate'>To celebrate with:</p>
            <p className='names'>Supreet Kaur & Jordan Leigh</p>
            <p className='dates'>October 15th - October 19th 2025</p>
            <p className='venue'>Las Vegas, Nevada</p>
            {WHATSAPP_GROUP_CHAT_PASSWORDS.includes(targetName) && (
              <div
                className='action-button submit'
                onClick={handleMore}>
                <p className='action-button-text'>CLICK FOR MORE</p>
              </div>
            )}
            {TELEGRAM_GROUP_CHAT_PASSWORDS.includes(targetName) && (
              <div
                className='action-button submit'
                onClick={handleMoreTelegram}>
                <p className='action-button-text'>CLICK FOR MORE</p>
              </div>
            )}
          </div>
        </div>
      )}

    </div>
  )
}
